/**
 * 「⚠️ 새로 들어온 요금제 N건 — 구간표에 넣어 주세요 · 보러 가기」 띠 (티켓 #862).
 *
 * 통신사가 새 요금제를 내면 요청자 엑셀에는 아직 없으니 자동으로 가입불가가 된다 — 모르고
 * 지나가면 팔 수 있는 것을 못 파는 셈이라, **어느 화면에 있든 맨 위에** 알린다.
 *
 * 세 가지가 이 컴포넌트의 전부다:
 *  · **운영사에게만 보인다** — 「요금제군 한눈에」 표를 고칠 수 있는 권한(`hasHqDelegation`)이 있어야
 *    한다. 매장 직원은 봐도 해결할 수가 없고, 못 없애는 경고가 늘 떠 있으면 아무도 안 읽게 된다.
 *  · **화면을 열 때 한 번만 물어본다.** 몇 초마다 자동 갱신하지 않는다 — 이 서비스는 저녁 시간대에
 *    요청이 10배로 뛴다.
 *  · **엑셀에 넣고 저장할 때까지 계속 떠 있는다.** 저장하면 서버가 「마지막 저장 시각」을 옮기므로
 *    그 뒤에 들어온 것만 남고, 이 띠는 저절로 사라진다.
 */
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { useAuth } from "../context/AuthContext";
import { fetchNewlyAddedPlans } from "../pages/Policy/policyApi";

export default function NewPlansBanner() {
  const { hasHqDelegation } = useAuth();
  const enabled = hasHqDelegation();
  const newPlansQ = useQuery({
    queryKey: ["policy", "new-plans"],
    queryFn: fetchNewlyAddedPlans,
    enabled,
    // 화면을 열 때 한 번만. 자동 갱신도, 창을 다시 볼 때의 재조회도 걸지 않는다.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const total = newPlansQ.data?.total ?? 0;
  if (!enabled || total === 0) return null;

  const names = (newPlansQ.data?.plans ?? []).slice(0, 3).map((plan) => plan.planName).join(", ");
  return (
    <div
      className="flex items-center gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
      role="status"
      data-testid="new-plans-banner"
    >
      <span className="font-semibold">⚠️ 새로 들어온 요금제 {total.toLocaleString()}건 — 구간표에 넣어 주세요</span>
      {names && <span className="hidden truncate text-amber-800 dark:text-amber-200 sm:inline">{names}{total > 3 ? " 외" : ""}</span>}
      <Link to="/policy/plan-group-matrix" className="ml-auto shrink-0 rounded-lg bg-amber-500 px-3 py-1 font-semibold text-white hover:bg-amber-600">
        보러 가기
      </Link>
    </div>
  );
}
